/* eslint-disable */
import { useEffect, useState } from "react";
import { Tooltip,IconButton, Grid } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import ChatModule from "../../Chat";
import { hasAuthority } from "../../../../utils/authorities";
import {capitalizeWords} from "../../../../utils/utils"
import Datatable from "../../../components/features/Datatable";
import { feasibilityPaymentStatus, selectApheresisLoading, selectFeasibilityPayments } from "../../../slices/apheresis";
import PaymentStatusModel from "./PaymentModel";
import BsModal from "../../../components/common/BaseModal";
import AddUpdatePayment  from "../../../components/taskNotificationTile/AddUpatePayment" 
import { EyeIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg"


const PaymentStatus = () => {
    const dispatch = useDispatch();
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const isLoading = useSelector(selectApheresisLoading);
    const feasibilityPayments = useSelector(selectFeasibilityPayments)
    const [addModal, setAddModel] = useState(false)
    const [viewDetails, setViewDetails] = useState({})
    const [editModal, setEditModal] = useState(false)

    const tableData = {
        items: feasibilityPayments?.data || [],
        total_count:
            feasibilityPayments?.pageDetails?.total_count ||
            0,
        page: feasibilityPayments?.pageDetails?.page || 1,
        per_page: feasibilityPayments?.pageDetails?.per_page || 10,
    };

    const handleServerSideChange = async (params) => {
        try {
            await dispatch(feasibilityPaymentStatus(params))
        } catch (error) {
            console.error("Error fetching quality approval data:", error);
        }
    };


    const handleCloseModal = () =>{
        setEditModal(false)
       handleServerSideChange({ page: 1, per_page: 10 }); 
    }

    // Initial data fetch
    useEffect(() => {
        if (hasAuthority(["bmr-slots-view"], bmr_permissions)) {
            handleServerSideChange({ page: 1, per_page: 10 });
        }
    }, [bmr_permissions]);

    const columns = [
        {
            id: "subject_code",
            name: "ID",
            selector: (row) => (row.patient_id ? row.patient_id : "N/A"),
            sortable: true,
        },
        {
            id: "subject_name",
            name: "Subject Name",
            selector: (row) => (row.subject_name ? capitalizeWords(row.subject_name) : "N/A"),
            sortable: true,
        },
        {
            id: "product",
            name: "Product/Phase",
            selector: (row) =>
                row.product && row.phase ? `${capitalizeWords(row.product)}/${capitalizeWords(row.phase)}` : "N/A",
            sortable: true,
        },
        {
            id: "phase_type",
            name: "Type",
            selector: (row) => (row.phase_type ? row.phase_type : "N/A"),
            sortable: true,
        },
        {
            id: "hospital_name",
            name: "Hospital",
            selector: (row) =>
                row?.hospitals?.length > 0
                ? row.hospitals?.map((it) => it?.name).join(" | ")
                : "N/A",
            sortable: true,
            },
        {
            id: "payment_status",
            name: "Payment Status",
            selector: (row) =>
                row.payment_status ? (row.payment_status
                ) : (
                    "Pending"
                ),
            sortable: true,
        },
        {
            name: "Action",
            selector: (row) => (
                <div className="flex gap-2 relative">
                     {hasAuthority(["payment-dash-view"], bmr_permissions) &&
                     <Tooltip title="View Details"  key={'key_'+row?.subject_id}>
                                        <span  key={'key_'+row?.subject_id}>
                                            <IconButton
                        onClick={() => {  setEditModal(false), setAddModel(true), setViewDetails(row) }}
                                            >
                                                <EyeIconButton
                                                    bgColor={"#3571FF"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>}
                     {hasAuthority(["update-payment-status"], bmr_permissions) &&
                      <Tooltip title="Edit"  key={row?.subject_id}>
                                        <span  key={row?.subject_id}>
                                            <IconButton
                               onClick={() => {setAddModel(false), setEditModal(true), setViewDetails(row) }}
                                            >
                                                <EditIconButton
                                                    bgColor={"#3571FF"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>}
                     
                </div>
            ),
        },
    ];

    return (
        <Grid
            container
            className="mt-4 ml-0 mr-3 mainDiv"
            rowSpacing={4.5}
            columnSpacing={2.75}
        >
            <BsModal open={addModal} onClose={() => setAddModel(false)} title={"Payment Details "}>
                <PaymentStatusModel data={viewDetails} />
            </BsModal>
            <BsModal open={!!editModal} onClose={() => setEditModal(false)} title={`Update Payment Status`}>
                <AddUpdatePayment editData={viewDetails}  feasiblityId={viewDetails?.id}  handleCloseModal={handleCloseModal}/>
            </BsModal>
            <Grid item xs={12} sx={{ mt: -2.25 }}>
                {hasAuthority(["bmr-slots-view"], bmr_permissions) && (
                    <div>
                        <Datatable
                            columns={columns}
                            data={tableData}
                            title="Payment Dashboard"
                            onServerSideChange={handleServerSideChange}
                            remote={true}
                            loading={isLoading}
                        />
                        <ChatModule />
                    </div>
                )}
            </Grid>
        </Grid>
    );
}

export default PaymentStatus;
